export default function AboutSection() {
  const values = [
    { icon: "ri-flashlight-line", title: "更新快", desc: "热门韩漫连载定时同步，第一时间送达最新章节" },
    { icon: "ri-notification-3-line", title: "提醒准", desc: "追更提醒稳定可靠，不错过任何一话更新" },
    { icon: "ri-settings-3-line", title: "体验顺", desc: "简洁流畅的浏览与追更体验，每日打开都有新内容" },
    { icon: "ri-shield-check-line", title: "内容全", desc: "玄幻、恋爱、热血、悬疑等多题材持续收录" },
  ];

  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-700 px-3 py-1 text-xs">
            <i className="ri-information-line"></i>关于我们
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">让追更更省心的韩漫平台</h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            韩国漫画yy专注于韩漫连载的每日更新与追更提醒服务。我们持续整理和同步热门韩漫的最新章节，
            帮助每一位追更用户用最少的时间看到最多的新内容。无论你追的是玄幻热血，还是恋爱悬疑，
            设置一次追更提醒，之后的每一次更新都不会错过。
          </p>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            我们相信，好的追更体验不只是「更新够快」，更是「提醒够准、够省心」——这也是我们始终坚持
            内容原则、不断打磨产品的初衷。
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {values.map((v) => (
              <div key={v.title} className="flex gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                <span className="w-10 h-10 shrink-0 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-lg">
                  <i className={v.icon}></i>
                </span>
                <div>
                  <h3 className="font-medium text-sm text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-xl overflow-hidden">
          <img
            src="https://comtock.github.io/api/search-image?query=illustration%20of%20a%20cozy%20reading%20corner%20with%20open%20comic%20books%20and%20phone%20with%20notification%20reminder%20on%20desk%2C%20warm%20artistic%20flat%20style%2C%20vibrant%20manhwa%20inspired%20colors%2C%20clean%20composition&width=900&height=760&seq=about-manhwa&orientation=portrait"
            alt="韩国漫画yy追更阅读场景"
            className="w-full h-72 md:h-[420px] object-cover"
          />
        </div>
      </div>
    </section>
  );
}